<template>
  <div class="header_wrapper">
    <div class="header_bar">
      <div class="header_logo" @click="naviJump('', '/home')">
        <!-- <img src="../../assets/imgs/header_logo.png" alt="" /> -->
        <p>
          环境信用·中国
          <br />
          <span>ENVIROMENTAL CREADIT · CHINA</span>
          <br />
          <!-- <span>单位环境信用信息公开平台</span> -->
        </p>
      </div>
      <!-- <img style="height:100%" src="../../assets/imgs/header_quote.png" alt="" /> -->
      <!-- <p style="font-family:'仿宋';color:white;font-size:32px;font-weight:bold;letter-spacing:1.5em">鉴心 鉴行 鉴天下</p> -->
      <div class="header_user">
        <!-- <div class="floating_Search">
        
          <transition name="el-fade-in">
            <div class="searchBar" v-if="searchVisible">
              <el-input
                placeholder="请输入内容"
                v-model="searchInput"
                class="input-with-select"
              >
                <el-select
                  style="width: 140px"
                  v-model="searchSelect"
                  slot="prepend"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in searchOptions"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
           
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="submitSearch"
                ></el-button>
              </el-input>
            </div>
          </transition>
        </div> -->
        <p>
          <!-- <span style="width:100%;height:2em" class="login_userName" v-if="userLoggedIn"
            >欢迎：{{ userInfo.NickName }}</span
          > -->
          <transition name="el-fade-in">
            <div class="searchBar" v-if="searchVisible">
              <el-input
                placeholder="请输入内容"
                v-model="searchInput"
                class="input-with-select"
              >
                <el-select
                  style="width: 140px"
                  v-model="searchSelect"
                  slot="prepend"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in searchOptions"
                    :label="item.label"
                    :value="item.value"
                    :key="index"
                  ></el-option>
                </el-select>

                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="submitSearch"
                ></el-button>
              </el-input>
            </div>
          </transition>
        </p>
        <!-- <font-awesome-icon
          class="loginBtn"
          v-else
          @mouseenter="accountTabVisible = true"
          icon="user-circle"
        /> -->

        <div v-if="!userLoggedIn" @click="showLoginDialog()" class="loginBtn">
          <span>登录/注册</span
          ><img src="../../assets/imgs/user_logo.png" alt="" />
        </div>
        <div @mouseenter="accountTabVisible = true" v-else class="loginBtn">
          <span @click="naviJump('后台菜单', '/system')">个人中心</span
          ><img src="../../assets/imgs/user_logo.png" alt="" />
        </div>
        <transition name="el-fade-in">
          <div
            v-if="accountTabVisible"
            @mouseleave="accountTabVisible = false"
            class="account_tab"
          >
            <ul>
              <li>{{ userInfo.NickName }}</li>
              <li @click="changePasswordVisible = true">修改密码</li>
              <li @click="naviJump('后台菜单', '/system')">后台菜单</li>
              <li @click="logOut">退出登录</li>
            </ul>
          </div>
        </transition>
      </div>
    </div>
    <div class="header_navi" v-if="isNav">
      <div class="header_naviStripe"></div>
      <div class="header_naviBox">
        <div class="left"></div>
        <div class="mid">
          <ul>
            <li
              @click="naviJump('首页', '/home')"
              style="font-weight: bolder; font-size: 22px"
            >
              首页
            </li>
            <li @click="jumpToZyj">环境信用评价</li>
            <li
              v-for="item in naviList"
              :class="{ naviActvited: item.current, disabled: !item.path }"
              @click="naviJump(item.label, item.path)"
            >
              {{ item.label }}
            </li>
            <!-- <li @click="jumpToBigScreen">全国区域环境信用</li> -->
            <!-- <li @click="checkMore(218, '专题研讨')">专题研讨</li>
            <li @click="checkMore(219, '人才培养')">人才培养</li> -->
          </ul>
        </div>
        <div class="right"></div>
      </div>
    </div>

    <v-app v-if="loginVisible || changePasswordVisible">
      <v-row justify="center">
        <!-- 登录/注册弹框 -->

        <v-dialog v-model="loginVisible" persistent max-width="600px">
          <v-card style="overflow: hidden">
            <v-card-title>
              <template v-for="item in loginTabs">
                <span v-if="item.current" class="headline">{{
                  item.label
                }}</span>
              </template>
            </v-card-title>
            <v-row align="center" justify="space-around">
              <template v-for="item in loginTabs">
                <v-btn
                  text
                  :plain="!item.current"
                  color="primary"
                  @click="setCurrentTab(item.label)"
                  >{{ item.label }}</v-btn
                >
              </template>
            </v-row>
            <v-card-text>
              <template v-for="item in loginTabs">
                <v-container v-if="item.current && item.label == '登录'">
                  <LoginForm
                    :item="item"
                    :loginForm="loginForm"
                    @setLoginValue="setLoginValue"
                  ></LoginForm>
                </v-container>
                <v-container v-if="item.current && item.label == '注册'">
                  <RegisterForm
                    :item="item"
                    :registerForm="registerForm"
                    @setRegisterValue="setRegisterValue"
                  ></RegisterForm>
                </v-container>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="showRecoverPassword()">
                找回密码
              </v-btn>
              <v-btn color="blue darken-1" text @click="loginVisible = false">
                取消
              </v-btn>
              <v-btn
                depressed
                color="primary"
                outlined
                @click="submitTrigger()"
              >
                提交
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="searchVisible" persistent max-width="600px">
        </v-dialog>

        <!-- //修改密码 -->

        <v-dialog v-model="changePasswordVisible" persistent max-width="600px">
          <v-card style="overflow: hidden">
            <v-card-title> 修改密码 </v-card-title>

            <v-card-text>
              <v-form
                v-model="changePasswordForm.valid"
                ref="changePasswordForm"
              >
                <v-row> </v-row>
                <v-col cols="12">
                  <v-text-field
                    label="旧密码"
                    type="password"
                    clearable
                    v-model="changePasswordForm.oldPassword"
                    :rules="changePasswordForm.oldPasswordRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="新密码"
                    type="password"
                    clearable
                    v-model="changePasswordForm.newPassword"
                    :rules="changePasswordForm.newPasswordRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="确认新密码"
                    type="password"
                    clearable
                    v-model="changePasswordForm.newPassword2"
                    :rules="
                      changePasswordForm.newPassword2Rules.concat(
                        validateChangeConfirmPassword
                      )
                    "
                  ></v-text-field>
                </v-col>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="changePasswordVisible = false"
              >
                取消
              </v-btn>
              <v-btn
                depressed
                color="primary"
                outlined
                @click="submitChangePassword()"
              >
                提交
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="recoverPasswordVisible" persistent max-width="600px">
          <v-card style="overflow: hidden">
            <v-card-title> 找回密码 </v-card-title>
            <v-card-text>
              <v-form
                v-model="recoverPasswordForm.valid"
                ref="recoverPasswordForm"
              >
                <v-row> </v-row>
                <v-col cols="12">
                  <v-text-field
                    label="登录名"
                    clearable
                    v-model="recoverPasswordForm.loginName"
                    :rules="recoverPasswordForm.loginnameRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="企业或个人名称"
                    clearable
                    v-model="recoverPasswordForm.name"
                    :rules="recoverPasswordForm.nameRules"
                  ></v-text-field>
                </v-col>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="primary" @click="jumpToRecoverySubmit()">
                申诉找回
              </v-btn>
              <v-spacer></v-spacer>

              <v-btn
                color="blue darken-1"
                text
                @click="recoverPasswordVisible = false"
              >
                取消
              </v-btn>
              <v-btn
                depressed
                color="primary"
                outlined
                @click="submitRecoverPassword()"
              >
                提交
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-app>

    <!-- <div style="width:100%;border:2px solid red"></div> -->
    <!-- <div
      class="floating_Old"
      @click="jumpToOld()"
      v-if="jumpToOldVisible && isNav"
    >
      动态评价
    </div> -->
    <!-- <div class="floating_Old2" @click="jumpToOld2()" v-if="jumpToOldVisible && isNav">
      切换旧版
    </div> -->
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations: homeMutations, mapState: homeState } =
  createNamespacedHelpers("home");
const { mapMutations: userMutations, mapState: userState } =
  createNamespacedHelpers("user");
import Captcha from "./Captcha";
import LoginForm from "./headerForms/LoginForm";
import RegisterForm from "./headerForms/RegisterForm";
import api from "../../http/apis/apis";
export default {
  mounted() {
    this.loginVisible = true;
    this.loginVisible = false;
  },
  data() {
    return {
      loginVisible: false,
      accountTabVisible: false,
      changePasswordVisible: false,
      recoverPasswordVisible: false,
      loginTabs: [
        { label: "登录", current: true },
        { label: "注册", current: false },
      ],
      searchOptions: [
        { label: "环境信息公开", value: "1" },
        // { label: "环境信用等级 ", value: "2" },
        { label: "站内文章", value: "3" },
      ],
      searchInput: "",
      searchSelect: "1",
      searchVisible: true,
      captchaStr: "",
      loginForm: {
        valid: false,
        username: "",
        usernameRules: [(v) => !!v || "请输入用户名"],
        password: "",
        passwordRules: [(v) => !!v || "请输入密码"],
        loginCaptcha: "",
        loginCaptchaRules: [(v) => !!v || "请输入验证码"],
        wrongCaptcha: false,
      },
      registerForm: {
        valid: false,
        registerTypeList: [
          // { value: 1, label: "个人注册" },
          { value: 2, label: "企业注册" },
        ],
        registerType: "",
        registerTypeRules: [(v) => !!v || "请选择注册类型"],
        loginname: "",
        loginnameRules: [(v) => !!v || "请输入登录名"],
        username: "",
        usernameRules: [
          (v) => !!v || "请输入用户名",
          (v) => (v && v.length >= 6) || "用户名不得少于6位",
        ],
        orgCode: "",
        orgCodeRules: [(v) => !!v || "请输入组织机构代码"],
        areaCode: "",
        areaCodeRules: [(v) => !!v || "请选择地区"],
        password: "",
        passwordRules: [(v) => !!v || "请输入密码"],
        password2: "",
        password2Rules: [(v) => !!v || "请输入密码"],
        registerCaptcha: "",
        registerCaptchaRules: [(v) => !!v || "请输入验证码"],
        userTypesList: ["企事业单位用户"],
        userType: "",
      },
      changePasswordForm: {
        valid: false,
        username: "",
        oldPassword: "",
        oldPasswordRules: [(v) => !!v || "请输入旧密码"],
        newPassword: "",
        newPasswordRules: [(v) => !!v || "请输入新密码"],
        newPassword2: "",
        newPassword2Rules: [(v) => !!v || "请确认新密码"],
      },
      recoverPasswordForm: {
        valid: false,
        loginName: "",
        loginnameRules: [(v) => !!v || "请输入登录名"],
        name: "",
        nameRules: [(v) => !!v || "请输入企业或个人名称"],
      },
    };
  },
  computed: {
    ...homeState(["naviList", "jumpToOldVisible"]),
    ...userState(["userInfo", "userLoggedIn", "isNav"]),
  },
  created() {
    const currentPath = this.$router.history.current.path;

    this.setCurrentNaviByPath(currentPath);
    window.addEventListener("beforeunload", () => {
      if (this.userLoggedIn) {
        localStorage.setItem("userTemp", JSON.stringify(this.userInfo));
      }
    });
    const userTemp = localStorage.getItem("userTemp");
    if (userTemp) {
      this.setUserInfo(JSON.parse(userTemp));
    }
  },

  methods: {
    ...homeMutations([
      "setCurrentNavi",
      "setCurrentNaviByPath",
      "setJumpToOldVisible",
    ]),
    ...userMutations(["setUserInfo", "resetUserInfo"]),
    checkMore(id, name) {
      this.$router.push(`/article/articlelist?listid=${id}&listname=${name}`);
    },
    jumpToOld() {
      // window.open("http://221.10.90.154:8090", "_blank");
      window.open("https://sc.hjxy.org.cn/", "_blank");
    },
    // jumpToOld2() {
    //   window.open("http://221.10.90.154:8090", "_blank");
    //   // window.open("http://221.10.90.140:8091/", "_blank");
    // },
    setLoginValue(obj) {
      this.loginForm = obj;
    },
    setRegisterValue(obj) {
      this.registerForm = obj;
    },
    resetLoginForm() {
      this.loginForm = {
        valid: false,
        username: "",
        usernameRules: [(v) => !!v || "请输入用户名"],
        password: "",
        passwordRules: [(v) => !!v || "请输入密码"],
        loginCaptcha: "",
        loginCaptchaRules: [(v) => !!v || "请输入验证码"],
        wrongCaptcha: false,
      };
    },
    resetRecoverPasswordForm() {
      this.recoverPasswordForm = {
        valid: false,
        loginName: "",
        loginnameRules: [(v) => !!v || "请输入登录名"],
        name: "",
        nameRules: [(v) => !!v || "请输入企业或个人名称"],
      };
    },
    resetRegisterForm() {
      this.registerForm = {
        valid: false,
        registerTypeList: [
          { value: 1, label: "个人注册" },
          { value: 2, label: "企业注册" },
        ],
        registerType: "",
        registerTypeRules: [(v) => !!v || "请选择注册类型"],
        loginname: "",
        loginnameRules: [(v) => !!v || "请输入登录名"],
        username: "",
        usernameRules: [(v) => !!v || "请输入用户名"],
        orgCode: "",
        orgCodeRules: [(v) => !!v || "请输入组织机构代码"],
        areaCode: "",
        areaCodeRules: [(v) => !!v || "请选择地区"],
        password: "",
        passwordRules: [(v) => !!v || "请输入密码"],
        password2: "",
        password2Rules: [(v) => !!v || "请输入密码"],
        registerCaptcha: "",
        registerCaptchaRules: [(v) => !!v || "请输入验证码"],
        userTypesList: ["企事业单位用户"],
        userType: "",
      };
    },
    showSearch() {
      console.info("triggered");
      this.searchVisible = !this.searchVisible;
    },
    showRecoverPassword() {
      this.recoverPasswordVisible = true;
    },
    validateChangeConfirmPassword(val) {
      return val == this.changePasswordForm.newPassword || "两次密码不一致";
    },
    naviJump(str, path) {
      const currentPath = this.$router.history.current.path;
      if (path && path != currentPath) {
        this.setCurrentNavi(str);
        const routerData = this.$router.resolve(path);
        window.open(routerData.href, "_blank");
        // this.$router.push(path);
      } else {
        this.setCurrentNaviByPath(path);
      }
    },
    jumpToZyj() {
      const token = localStorage.getItem("ecc_token");
      window.open(
        `http://www.hjxy.org.cn/WebForm/Head/Login2?cacheKey=${token}`,
        "_blank"
      );
    },
    jumpToBigScreen() {
      // const token=localStorage.getItem('ecc_token')
      window.open(`http://221.10.90.140:8086/`, "_blank");
    },
    jumpToRecoverySubmit() {
      const path = `/misc/passrecoverysubmit`;
      const routerData = this.$router.resolve(path);
      window.open(routerData.href, "_blank");
    },
    setCurrentTab(str) {
      this.loginTabs.forEach((item) => {
        item.current = false;
        if (item.label == str) {
          item.current = true;
        }
      });
      switch (str) {
        case "登录":
      }
    },
    checkMore(id, name) {
      // this.$router.push(`/article/articlelist?listid=${id}&listname=${name}`);
      const path = `/article/articlelist?listid=${id}&listname=${name}`;
      const routerData = this.$router.resolve(path);
      window.open(routerData.href, "_blank");
    },
    // setCaptchaNum(val) {
    //   this.captchaStr = val;
    // },
    showLoginDialog() {
      this.loginVisible = true;
    },
    submitTrigger() {
      this.loginTabs.forEach((item) => {
        if (item.current) {
          switch (item.label) {
            case "登录":
              this.submitLogin();
              break;
            case "注册":
              if (this.registerForm.areaCode) {
                this.submitRegister();
              } else {
                alert("请选择行政区划！");
              }
              break;
          }
        }
      });
    },
    async submitSearch() {
      let routerData = null;
      switch (this.searchSelect) {
        case "1":
          console.info(this.searchInput);
          routerData = this.$router.resolve(
            `/infoPublication/infoPublicationMain?search=${this.searchInput}`
          );
          window.open(routerData.href, "_blank");
        case "3":
          console.info(this.searchInput);
          routerData = this.$router.resolve(
            `/article/articlelistsearch?search=${this.searchInput}`
          );
          window.open(routerData.href, "_blank");
      }
    },
    async submitChangePassword() {
      const { data } = await api.userApi.changePassword({
        loginname:this.loginForm.username|| this.userInfo.LoginName,
        oldpass: this.changePasswordForm.oldPassword,
        newpass: this.changePasswordForm.newPassword,
      });
      if (data.IsSuccessful) {
        this.$message({
          message: "修改成功！请重新登录",
          type: "success",
        });
        this.resetUserInfo();
        this.changePasswordVisible = false;
      } else {
        this.$message({
          message: data.ResultMsg,
          type: "error",
        });
      }
    },

    async submitRecoverPassword() {
      if (this.recoverPasswordForm.valid) {
        const { data } = await api.userApi.recoverPassword({
          LoginName: this.recoverPasswordForm.loginName,
          Name: this.recoverPasswordForm.name,
        });
        if (data.IsSuccessful) {
          this.$message({
            message: "密码已通过短信形式发送到绑定的手机号，请注意查收",
            type: "success",
          });
          this.resetRecoverPasswordForm();
          this.recoverPasswordVisible = false;
          this.loginVisible = false;
        } else {
          this.$message({
            message: data.ResultMsg,
            type: "error",
          });
        }
      }
    },
    // async tokenLogin(token) {
    //   const { data } = await api.userApi.loginViaToken(token);
    //   if (data.IsSuccessful) {
    //     localStorage.setItem("ecc_token", data.ResultData);
    //     this.setUserInfo(data.ResultObj);
    //     this.resetLoginForm();
    //     this.resetRegisterForm();
    //     this.loginVisible = false;
    //     localStorage.setItem("userTemp", JSON.stringify(this.userInfo));
    //     // const url = new URL(location);
    //     // url.searchParams.delete("eca_pub_i");
    //     delete this.$route.query.eca_pub_i;
    //   } else {
    //     this.$message({
    //       message: "自动登陆失败，请手动登录",
    //       type: "error",
    //     });
    //   }
    // },

    async submitLogin() {
      if (this.loginForm.valid) {
        const { data } = await api.userApi.login({
          logname: this.loginForm.username,
          password: this.loginForm.password,
        });
        if (data.IsSuccessful) {
          localStorage.setItem("ecc_token", data.ResultData);
          this.setUserInfo(data.ResultObj);
          this.resetLoginForm();
          this.resetRegisterForm();
          this.loginVisible = false;
          localStorage.setItem("userTemp", JSON.stringify(this.userInfo));
          this.$message({
            message: "登录成功！",
            type: "success",
          });
          // setTimeout(() => {
          //   window.location.reload();
          // }, 1500);
        } else {
          if (data.ResultMsg) {
            this.$message({
              message: data.ResultMsg,
              type: "error",
            });
            if(data.ResultData=='PassWordRules'){
              this.changePasswordVisible=true
              this.changePasswordForm.oldPassword=this.loginForm.password
        this.changePasswordForm.username=this.loginForm.username
        }
          } else {
            this.$message({
              message: "登录失败！",
              type: "error",
            });
          }
        }
      }
    },
    async submitRegister() {
      if (this.registerForm.valid) {
        const params = {
          loginname: this.registerForm.loginname,
          newpass: this.registerForm.password,
          name: this.registerForm.username,
          orgcode: this.registerForm.orgCode,
          stype: this.registerForm.registerType,
          regionId: this.registerForm.areaCode,
          remark: "",
          faren: "",
          farentel: "",
          faren2tel: "",
          faren2: "",
          registType: "web",
        };
        const { data } = await api.userApi.register(params);
        if (data.IsSuccessful) {
          localStorage.setItem("ecc_token", data.ResultData);
          this.resetLoginForm();
          this.resetRegisterForm();
          this.$message({
            message: "注册成功！",
            type: "success",
          });
          this.setCurrentTab("登录");
        } else {
          if (data.ResultMsg) {
            this.$message({
              message: data.ResultMsg,
              type: "error",
            });
          } else {
            this.$message({
              message: "注册失败！",
              type: "error",
            });
          }
        }
      }
    },
    logOut() {
      localStorage.removeItem("userTemp");
      this.resetUserInfo();
      // this.$router.push("/home");
    },
  },
  components: {
    Captcha,
    LoginForm,
    RegisterForm,
  },
};
</script>

<style lang="scss" scoped>
$primaryColor: #ea5b24;
$secondaryColor: #525c66;
$tertiaryColor: #8f8e8c;
@import "../../assets/scss/home/homeHeader.scss";
::v-deep .el-input__inner {
  min-width: 120px;
  background-color: $primaryColor;
  color: white;
  height: 40px;
  border: 1px solid white;
}
::v-deep .el-select {
  background-color: $primaryColor;
  color: white;
  height: 40px;
  border: 1px solid white;
}

::v-deep .el-button {
  background: $primaryColor;
}
::v-deep .el-input-group__append {
  background-color: $primaryColor;
  color: white;
}
</style>